"use client";

import React from "react";
import DiagnosisForm from "./components/DiagnosisForm";

// 診断フォームへスクロールする関数
const scrollToDiagnosisForm = () => {
  const element = document.getElementById('diagnosis-form');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

// ローカル画像パス（/public/images/truemee/sp/）
const img4 = "/images/truemee/sp/hero-person.jpg"; // ヒーロー画像
const imgAdobeStock5582371022 = "/images/truemee/sp/cta-bg.jpg"; // CTA背景2
const imgAdobeStock12291495202 = "/images/truemee/sp/testimonial-woman-1.jpg"; // 女性の証言1
const img202511281800252 = "/images/truemee/sp/author-photo.jpg"; // 著者写真2
const imgImg94682 = "/images/truemee/sp/book-cover.jpg"; // 書籍カバー2
const imgAdobeStock3889188532 = "/images/truemee/sp/support-1.jpg"; // サポート1
const imgAdobeStock4267875072 = "/images/truemee/sp/support-2.jpg"; // サポート2
const imgAdobeStock4738159762 = "/images/truemee/sp/support-3.jpg"; // サポート3
const imgAdobeStock4588800722 = "/images/truemee/sp/cta-bg.jpg"; // CTA背景
const img1 = "/images/truemee/sp/bg-decoration-1.svg"; // 背景装飾1
const img2 = "/images/truemee/sp/bg-decoration-2.svg"; // 背景装飾2
const img3 = "/images/truemee/sp/bg-decoration-3.svg"; // 背景装飾3
const imgGroup = "/images/truemee/sp/menu-icon.svg"; // メニューアイコン
const imgLogo = "/images/truemee/sp/logo.svg"; // ロゴ
const img01 = "/images/truemee/sp/hero-mask.svg"; // ヒーローマスク
const imgPolygon1 = "/images/truemee/sp/polygon1.svg"; // 三角矢印1
const imgVector = "/images/truemee/sp/check-orange.svg"; // チェック（オレンジ）
const imgGroup6 = "/images/truemee/sp/decoration-curve.svg"; // 装飾カーブ
const imgVector1 = "/images/truemee/sp/check-gray.svg"; // チェック（グレー）
const imgVector2 = "/images/truemee/sp/step-check.svg"; // ステップチェック
const imgVector3 = "/images/truemee/sp/check-orange-2.svg"; // チェック（オレンジ）2
const imgVector4 = "/images/truemee/sp/check-gray-2.svg"; // チェック（グレー）2
const imgVector5 = "/images/truemee/sp/check-orange-3.svg"; // チェック（オレンジ）3
const imgEllipse25 = "/images/truemee/sp/ellipse-dot.svg"; // 楕円ドット
const imgPolygon2 = "/images/truemee/sp/polygon2.svg"; // 三角矢印2
const imgLine8 = "/images/truemee/sp/line-left.svg"; // 左ライン
const imgLine9 = "/images/truemee/sp/line-right.svg"; // 右ライン
const imgVector6 = "/images/truemee/sp/check-gray-3.svg"; // チェック（グレー）3
const imgVector7 = "/images/truemee/sp/decoration-star-1.svg"; // 装飾星1
const imgAdobeStock5582371021 = "/images/truemee/sp/cta-bg.jpg"; // CTA背景
const imgAdobeStock12291495201 = "/images/truemee/sp/testimonial-woman-2.jpg"; // 女性の証言2
const img = "/images/truemee/sp/testimonial-mask-1.svg"; // 証言マスク1
const img5 = "/images/truemee/sp/testimonial-mask-2.svg"; // 証言マスク2
const imgVector8 = "/images/truemee/sp/decoration-star-2.svg"; // 装飾星2
const imgVector9 = "/images/truemee/sp/decoration-star-3.svg"; // 装飾星3
const img6 = "/images/truemee/sp/author-mask.svg"; // 著者マスク
const img202511281800251 = "/images/truemee/sp/author-photo.jpg"; // 著者写真
const imgImg94681 = "/images/truemee/sp/book-cover.jpg"; // 書籍カバー
const imgContents = "/images/truemee/sp/support-1.jpg"; // サポート1
const imgContents1 = "/images/truemee/sp/support-2.jpg"; // サポート2
const imgContents2 = "/images/truemee/sp/support-3.jpg"; // サポート3
const imgVector10 = "/images/truemee/sp/decoration-star-4.svg"; // 装飾星4
const img7 = "/images/truemee/sp/book-mask.svg"; // 書籍マスク
const imgAdobeStock3889188531 = "/images/truemee/sp/step-icon-1.svg"; // ステップアイコン1
const imgAdobeStock4267875071 = "/images/truemee/sp/step-icon-2.svg"; // ステップアイコン2
const imgVector11 = "/images/truemee/sp/decoration-star-5.svg"; // 装飾星5
const imgAdobeStock4738159761 = "/images/truemee/sp/step-icon-3.svg"; // ステップアイコン3
const imgStepIcon4 = "/images/truemee/sp/step-icon-4.svg"; // ステップアイコン4（握手）
const img8 = "/images/truemee/sp/support-1-mask.svg"; // サポート1マスク
const imgSupport2Mask = "/images/truemee/sp/support-2-mask.svg"; // サポート2マスク
const imgSupport3Mask = "/images/truemee/sp/support-3-mask.svg"; // サポート3マスク
const imgEllipse23 = "/images/truemee/sp/qa-circle-orange.svg"; // Q&A丸（オレンジ）
const imgEllipse24 = "/images/truemee/sp/qa-circle-white.svg"; // Q&A丸（白）
const imgAdobeStock4588800721 = "/images/truemee/sp/cta-bg-mask.svg"; // CTA背景マスク
const imgLine10 = "/images/truemee/sp/line-left-white.svg"; // 左ライン（白）
const imgLine11 = "/images/truemee/sp/line-right-white.svg"; // 右ライン（白）
const img9 = "/images/truemee/sp/footer-logo.svg"; // フッターロゴ

export default function TruemeeSpA() {
  const openMenu = () => {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("open-dashboard-menu"));
    }
  };
  return (
    <div
      style={{
        backgroundColor: '#fffaf8',
        position: 'relative',
        width: '750px',
        height: '20100px',
        fontFamily: "'Noto Sans JP', sans-serif",
      }}
      data-name="truemee_sp_A"
      data-node-id="12:27"
    >
        {/* 背景装飾 */}
      <div style={{ position: 'absolute', height: '432px', left: '493px', top: '-76px', width: '434px' }} data-name="_饑1">
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={img1} />
      </div>
      <div style={{ position: 'absolute', height: '432px', left: '-198px', top: '356px', width: '434px' }} data-name="_饑1">
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={img2} />
      </div>
      <div style={{ position: 'absolute', height: '302px', left: '514px', top: '944px', width: '303px' }} data-name="_饑1">
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={img3} />
      </div>

      {/* ヘッダー（固定） */}
      <div style={{ position: 'fixed', backgroundColor: 'white', height: '88px', left: 0, top: 0, width: '100%', maxWidth: '750px', zIndex: 50, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }} data-node-id="12:28">
        <div
          onClick={openMenu}
          role="button"
          aria-label="メニューを開く"
          style={{ position: 'absolute', left: '661px', overflow: 'clip', width: '57px', height: '57px', top: '15px', cursor: 'pointer' }}
          data-name="メニューの無料アイコン10 1"
        >
          <div style={{ position: 'absolute', bottom: '3.13%', left: 0, right: '17.25%', top: '19.3%' }} data-name="Group">
            <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgGroup} />
          </div>
        </div>
        <div style={{ position: 'absolute', height: '98px', left: '31px', top: '-16px', width: '257.403px' }} data-name="logo">
          <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgLogo} />
        </div>
      </div>
      {/* ヘッダー分のスペーサー */}
      <div style={{ position: 'absolute', height: '88px', left: 0, top: 0, width: '750px' }} />

      {/* サブコピー */}
      <div style={{ position: 'absolute', backgroundColor: '#FF733E', height: '41px', left: '137px', borderRadius: '20px', top: '140px', width: '470px' }} />
      <div style={{ position: 'absolute', backgroundColor: '#FF733E', height: '41px', left: '193px', borderRadius: '20px', top: '192px', width: '374px' }} />
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: '42px', left: '384px', fontSize: '28px', textAlign: 'center', color: 'white', top: '140px', letterSpacing: '1.4px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        書類が通らない"本当の理由"を、
      </p>
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: '42px', left: '384.5px', fontSize: '28px', textAlign: 'center', color: 'white', top: '192px', letterSpacing: '1.4px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        あなたは知っていますか？
      </p>

      {/* キャッチコピー */}
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 'normal', left: '55px', color: '#32291f', top: '276px', letterSpacing: '2.7635px' }}>
        <span style={{ color: '#ed7243', fontSize: '51.459px', letterSpacing: '2.5729px' }}>面接で勝てる職務経歴書</span>
        <span style={{ fontSize: '47.647px', letterSpacing: '2.3824px' }}>を</span>
      </p>
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 'normal', left: '31px', color: '#32291f', fontSize: '67.601px', top: '343px', height: '114.971px', width: '687px', whiteSpace: 'pre-wrap' }}>
        プロがマンツーマンで
      </p>
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 'normal', color: '#32291f', fontSize: '67.601px', left: '173px', top: '430px' }}>
        仕上げます。
      </p>

      {/* ヒーロー画像 */}
      <div style={{ position: 'absolute', backgroundColor: '#ed7243', height: '459px', left: '49px', borderRadius: '87px', top: '572px', width: '652px' }} />
      <div
        style={{
          position: 'absolute',
          height: '458px',
          left: '68px',
          top: '553px',
          width: '614px',
          borderRadius: '87px',
          overflow: 'hidden'
        }}
        data-name="レイヤー 0 1"
      >
        <img alt="" style={{ display: 'block', maxWidth: 'none', objectFit: 'cover', objectPosition: '50% 0%', pointerEvents: 'none', width: '100%', height: '130%' }} src={img4} />
      </div>

      {/* CTA ボタン1 */}
      <div onClick={scrollToDiagnosisForm} style={{ position: 'absolute', left: '49px', top: '1095px', width: '651px', height: '150px', cursor: 'pointer' }}>
        <div style={{ position: 'absolute', backgroundColor: '#f14d2c', height: '142.036px', left: '0', borderRadius: '71.018px', top: '8.78px', width: '651px' }} />
        <div style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', height: '142.036px', left: '0', borderRadius: '71.018px', top: '0', width: '651px' }} className="hover:opacity-90 transition-opacity" />
        <p style={{ position: 'absolute', fontWeight: 500, lineHeight: 'normal', left: '58px', fontSize: '32px', color: 'white', top: '52px', letterSpacing: '1.6px' }}>
          無料で職務経歴書の診断を受ける
        </p>
        <div style={{ position: 'absolute', display: 'flex', height: '29.266px', alignItems: 'center', justifyContent: 'center', left: '570.68px', top: '57.07px', width: '17.56px' }}>
          <div style={{ flexShrink: 0, transform: 'rotate(90deg)' }}>
            <div style={{ height: '17.56px', position: 'relative', width: '29.266px' }}>
              <div style={{ position: 'absolute', bottom: '25%', left: '6.7%', right: '6.7%', top: 0 }}>
                <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgPolygon1} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section2 - なぜTruemeeなら (私たちについて) */}
      <div id="about-us" style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 'normal', left: '385px', color: '#32291f', fontSize: '60px', textAlign: 'center', top: '1366px', letterSpacing: '3px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>なぜTruemeeなら</p>
        <p style={{ marginBottom: 0 }}>「選考を突破できる」</p>
        <p>職務経歴書になるのか？</p>
      </div>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: '48px', left: '36px', color: '#32291f', fontSize: '32px', top: '1654px', letterSpacing: '3.2px', width: '699px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>私たちは、AI添削や一般的なテンプレートでは絶対に発見できない、</p>
        <p style={{ marginBottom: 0 }}>
          <span style={{ fontWeight: 'bold' }}>「あなたの本質的な価値」</span>を引き出します。
        </p>
        <p style={{ marginBottom: 0 }}>&nbsp;</p>
        <p style={{ marginBottom: 0 }}>職務経歴書の書き方を熟知したプロが、</p>
        <p>あなたの過去の経験を独自のロジックで徹底的に深掘りします。</p>
      </div>

      {/* Before/After セクション1 */}
      <div style={{ position: 'absolute', backgroundColor: '#fdf5f2', height: '1200px', left: '31px', top: '2149px', width: '689px' }} />
      <div style={{ position: 'absolute', backgroundColor: '#ed7243', height: '219px', left: '31px', top: '2062px', width: '692px' }} />
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '375.5px', color: '#32291f', fontSize: '28px', textAlign: 'center', top: '2326px', letterSpacing: '2.8px', transform: 'translateX(-50%)', width: '689px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>課題は「訪問頻度は高いが、意思決定者に到達</p>
        <p>していない」点にあり、上層部向けの新提案資料を自作し、商談率を4倍に引き上げました。</p>
      </div>
      <div style={{ position: 'absolute', fontWeight: 'bold', lineHeight: '60px', left: '378px', fontSize: '40px', textAlign: 'center', color: 'white', top: '2083px', letterSpacing: '2px', transform: 'translateX(-50%)', width: '684px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>Truemeeでは"なぜ・どうやって・</p>
        <p style={{ marginBottom: 0 }}>どれだけ成果を出したか"が</p>
        <p>一目でわかるように添削しています</p>
      </div>

      {/* Before1 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', border: '1.109px solid #d9d9d9', height: '415px', left: '32px', top: '2513px', width: '691px' }} />
      <div style={{ position: 'absolute', backgroundColor: '#646464', height: '87.274px', left: '31px', top: '2512.12px', width: '692px' }} />
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '149px', color: '#32291f', fontSize: '29px', top: '2616px', letterSpacing: '2.9px', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>新規顧客開拓を担当し、</p>
        <p>売上アップに貢献しました。</p>
      </div>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '149px', color: '#32291f', fontSize: '29px', top: '2720px', letterSpacing: '2.9px', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>課題を発見し、改善施策の立案を</p>
        <p>行いました。</p>
      </div>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '149px', color: '#32291f', fontSize: '29px', top: '2824px', letterSpacing: '2.9px', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>チームで協力しながら業務効率化を</p>
        <p>進めました。</p>
      </div>
      {/* チェックマーク非表示 */}
      {/* <div style={{ position: 'absolute', top: '13.09%', right: '81.32%', bottom: '86.82%', left: '15.87%' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgVector} />
      </div> */}
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', height: '50.279px', lineHeight: 'normal', left: '322px', fontStyle: 'normal', fontSize: '40px', color: 'white', top: '2532.77px', letterSpacing: '2px', width: '142px', whiteSpace: 'pre-wrap' }}>
        Before
      </p>

      {/* 矢印 */}
      <div style={{ position: 'absolute', height: '61px', left: '349px', top: '2952px', width: '58px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgGroup6} />
      </div>

      {/* After1 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', border: '1px solid #ed7243', height: '303px', left: '33px', top: '3037px', width: '690px' }} />
      <div style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', height: '72px', left: '32px', top: '3037px', width: '691px' }} />
      <p style={{ position: 'absolute', fontWeight: 'normal', height: '167px', lineHeight: 1.5, left: '107px', color: '#32291f', fontSize: '28px', top: '3141px', letterSpacing: '2.8px', width: '560px', whiteSpace: 'pre-wrap' }}>
        前職では、担当エリアの休眠顧客72社の訪問戦略を立案し、3ヶ月で稼働率を18%→52%に改善。売上は前年比132%を達成。
      </p>
      {/* チェックマーク非表示 */}
      {/* <div style={{ position: 'absolute', top: '15.11%', right: '86.66%', bottom: '84.82%', left: '10.53%' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgVector1} />
      </div> */}
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '331px', fontStyle: 'normal', fontSize: '40px', color: 'white', top: '3050px', letterSpacing: '2px' }}>
        After
      </p>

      {/* Before/After セクション2 */}
      <div style={{ position: 'absolute', backgroundColor: '#fdf5f2', height: '1102px', left: '32px', top: '3556px', width: '688px' }} />
      <div style={{ position: 'absolute', backgroundColor: '#ed7243', height: '210px', left: '32px', top: '3420px', width: '691px' }} />
      <div style={{ position: 'absolute', fontWeight: 'bold', lineHeight: '54px', left: '385.5px', fontSize: '40px', textAlign: 'center', color: 'white', top: '3444px', letterSpacing: '2px', transform: 'translateX(-50%)', width: '687px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>Truemeeでは</p>
        <p style={{ marginBottom: 0 }}>フレームワークをメインに</p>
        <p>思考の流れを可視化します</p>
      </div>

      {/* Before2 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', border: '1px solid #d9d9d9', height: '399px', left: '32px', top: '3693px', width: '691px' }} />
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '106px', color: '#32291f', fontSize: '28px', top: '3992px', letterSpacing: '2.8px', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>見積作成、請求処理、問い合わせ対応を</p>
        <p>担当。</p>
      </div>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '106px', color: '#32291f', fontSize: '28px', top: '3887px', letterSpacing: '2.8px', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>製品知識を活かして新規顧客への</p>
        <p>提案を行う。</p>
      </div>
      <div style={{ position: 'absolute', backgroundColor: '#646464', height: '72px', left: '31px', top: '3694px', width: '692px' }} />
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '106px', color: '#32291f', fontSize: '28px', top: '3782px', letterSpacing: '2.8px', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>営業として顧客対応、受注管理、提案資料</p>
        <p>の作成などを経験。</p>
      </div>
      {/* チェックマーク非表示 */}
      {/* <div style={{ position: 'absolute', top: '18.68%', right: '86.53%', bottom: '81.25%', left: '11.2%' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgVector2} />
      </div> */}
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '314px', fontStyle: 'normal', fontSize: '40px', color: 'white', top: '3707px', letterSpacing: '2px' }}>
        Before
      </p>

      {/* 矢印2 */}
      <div style={{ position: 'absolute', height: '61px', left: '346px', top: '4124px', width: '58px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgGroup6} />
      </div>

      {/* After2 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', border: '1px solid #ed7243', height: '481px', left: '32px', top: '4217px', width: '691px' }} />
      <div style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', height: '72px', left: '31px', top: '4217px', width: '692px' }} />
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '105px', color: '#32291f', fontSize: '28px', top: '4305px', letterSpacing: '2.8px', width: '601px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>【役割】プロジェクト営業（顧客課題の</p>
        <p>{`  特定〜提案〜導入支援を一気通貫）`}</p>
      </div>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '105px', color: '#32291f', fontSize: '28px', top: '4605px', letterSpacing: '2.8px', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>【行動】営業プロセスの型化により、</p>
        <p>{`  メンバー3名の数字も改善`}</p>
      </div>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '105px', color: '#32291f', fontSize: '28px', top: '4505px', letterSpacing: '2.8px', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>【強み】顧客の「決裁プロセス（4段階）」</p>
        <p>{`  を可視化し、提案タイミングを最適化`}</p>
      </div>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '105px', color: '#32291f', fontSize: '28px', top: '4405px', letterSpacing: '2.8px', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>{`【成果】新規商談数 `}</p>
        <p>{`  月12件 → 21件（175%増）`}</p>
      </div>
      {/* チェックマーク非表示 */}
      {/* <div style={{ position: 'absolute', top: '20.68%', right: '84.66%', bottom: '79.25%', left: '12.53%' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgVector3} />
      </div> */}
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '330px', fontStyle: 'normal', fontSize: '40px', color: 'white', top: '4230px', letterSpacing: '2px' }}>
        After
      </p>

      {/* Before/After セクション3 */}
      <div style={{ position: 'absolute', backgroundColor: '#fdf5f2', height: '1176px', left: '32px', top: '4732px', width: '688px' }} />
      <div style={{ position: 'absolute', backgroundColor: '#ed7243', height: '209px', left: '32px', top: '4778px', width: '691px' }} />
      <div style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 1.5, left: '375.5px', fontSize: '40px', textAlign: 'center', color: 'white', top: '4793px', letterSpacing: '2px', transform: 'translateX(-50%)', width: '687px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>Truemeeでは数字の根拠など、</p>
        <p style={{ marginBottom: 0 }}>より具体的な指摘をし</p>
        <p>矛盾点を洗い出します</p>
      </div>

      {/* Before3 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', border: '1px solid #d9d9d9', height: '245px', left: '32px', top: '5038px', width: '691px' }} />
      <div style={{ position: 'absolute', backgroundColor: '#646464', border: '1px solid #d9d9d9', height: '72px', left: '31px', top: '5037px', width: '692px' }} />
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '110px', color: '#32291f', fontSize: '28px', top: '5125px', letterSpacing: '2.8px', width: '556.824px', whiteSpace: 'pre-wrap' }}>
        品質改善に取り組み、顧客満足度の向上に貢献しました。
      </p>
      {/* チェックマーク非表示 */}
      {/* <div style={{ position: 'absolute', top: '25.07%', right: '85.59%', bottom: '74.86%', left: '11.6%' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgVector4} />
      </div> */}
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '107px', color: '#32291f', fontSize: '28px', top: '5225px', letterSpacing: '2.8px' }}>
        トラブル対応にも積極的に取り組みました。
      </p>
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '314px', fontStyle: 'normal', fontSize: '40px', color: 'white', top: '5050px', letterSpacing: '2px' }}>
        Before
      </p>

      {/* 矢印3 */}
      <div style={{ position: 'absolute', height: '61px', left: '346px', top: '5315px', width: '58px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgGroup6} />
      </div>

      {/* After3 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', border: '1px solid #ed7243', height: '385px', left: '32px', top: '5411px', width: '689px' }} />
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '113px', color: '#32291f', fontSize: '28px', top: '5750px', letterSpacing: '2.8px' }}>
        半年で全ライン展開。
      </p>
      <div style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', height: '72px', left: '31px', top: '5408px', width: '690px' }} />
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '113px', color: '#32291f', fontSize: '28px', top: '5496px', letterSpacing: '2.8px', width: '541.613px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>品質不良率を2.1% → 0.6%へ改善し、</p>
        <p>クレーム件数を月5件 → 1件に減少。</p>
      </div>
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '113px', color: '#32291f', fontSize: '28px', top: '5620px', letterSpacing: '2.8px', width: '541.613px', whiteSpace: 'pre-wrap' }}>
        改善活動は製造・品質保証チームと合同で実施し、根本原因の再発防止策をマニュアル化。
      </p>
      {/* チェックマーク非表示 */}
      {/* <div style={{ position: 'absolute', top: '26.38%', right: '85.73%', bottom: '73.55%', left: '11.47%' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgVector5} />
      </div> */}
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '325px', fontStyle: 'normal', fontSize: '40px', color: 'white', top: '5421px', letterSpacing: '2px' }}>
        After
      </p>

      {/* CTA1 セクション */}
      <div style={{ position: 'absolute', left: '386.92px', width: '8.701px', height: '8.701px', top: '5969.23px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgEllipse25} />
      </div>
      <div style={{ position: 'absolute', left: '436.65px', width: '8.701px', height: '8.701px', top: '5969.23px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgEllipse25} />
      </div>
      <div style={{ position: 'absolute', left: '564.68px', width: '8.701px', height: '8.701px', top: '5969.23px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgEllipse25} />
      </div>
      <div style={{ position: 'absolute', left: '626.83px', width: '8.701px', height: '8.701px', top: '5969.23px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgEllipse25} />
      </div>

      {/* CTA ボタン2 */}
      <div onClick={scrollToDiagnosisForm} style={{ position: 'absolute', left: '34px', top: '6128.76px', width: '676.024px', height: '136.046px', cursor: 'pointer' }}>
        <div style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', height: '136.046px', left: '0', borderRadius: '68.07px', top: '0', width: '676.024px' }} className="hover:opacity-90 transition-opacity" />
        <p style={{ position: 'absolute', fontWeight: 500, lineHeight: 'normal', left: '61.71px', fontSize: '33.661px', color: 'white', top: '44.84px', letterSpacing: '1.683px' }}>
          無料で職務経歴書の診断を受ける
        </p>
        <div style={{ position: 'absolute', display: 'flex', height: '28.051px', alignItems: 'center', justifyContent: 'center', left: '614.31px', top: '54.66px', width: '16.83px' }}>
          <div style={{ flexShrink: 0, transform: 'rotate(90deg)' }}>
            <div style={{ height: '16.83px', position: 'relative', width: '28.051px' }}>
              <div style={{ position: 'absolute', bottom: '25%', left: '6.7%', right: '6.7%', top: 0 }}>
                <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgPolygon2} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <p style={{ position: 'absolute', fontWeight: 500, lineHeight: 'normal', left: '117.37px', color: '#32291f', fontSize: '28px', top: '6091px', letterSpacing: '1.4px' }}>
        あなたの職務経歴書もこう変わります
      </p>
      <div style={{ position: 'absolute', display: 'flex', height: '23.294px', alignItems: 'center', justifyContent: 'center', left: '105px', top: '6098px', width: '8.153px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(70.71deg)' }}>
          <div style={{ height: 0, position: 'relative', width: '24.679px' }}>
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, top: '-1.16px' }}>
              <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgLine8} />
            </div>
          </div>
        </div>
      </div>
      <div style={{ position: 'absolute', display: 'flex', height: '23.294px', alignItems: 'center', justifyContent: 'center', left: '617.4px', top: '6098.82px', width: '8.153px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(109.29deg) scaleY(-1)' }}>
          <div style={{ height: 0, position: 'relative', width: '24.679px' }}>
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, top: '-1.16px' }}>
              <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgLine9} />
            </div>
          </div>
        </div>
      </div>
      <div style={{ position: 'absolute', fontWeight: 'bold', lineHeight: '89.5px', left: '360px', color: '#32291f', fontSize: '59.667px', textAlign: 'center', top: '5876px', letterSpacing: '2.9833px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>これらの内容を</p>
        <p>今なら実質0円で無料</p>
      </div>

      {/* 選考を突破した先に広がる未来 (転職成功事例) */}
      <div id="success-stories" style={{ position: 'absolute', fontWeight: 'bold', lineHeight: '90px', left: '381px', color: '#32291f', fontSize: '60px', textAlign: 'center', top: '6384.81px', letterSpacing: '3px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>選考を突破した先に</p>
        <p>広がる未来</p>
      </div>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: '48px', left: '380.5px', color: '#32291f', fontSize: '32px', textAlign: 'center', top: '6612.81px', letterSpacing: '3.2px', transform: 'translateX(-50%)', width: '689px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>Truemeeの添削ロジックは、職務経歴書の悩みを本質的に解決し、選考突破という</p>
        <p style={{ marginBottom: 0 }}>具体的な成果に繋がっています。</p>
        <p style={{ marginBottom: 0 }}>私たちがサポートした方々の</p>
        <p>「生の声」と「実績」をご覧ください。</p>
      </div>

      {/* 装飾 */}
      <div style={{ position: 'absolute', display: 'flex', top: '34.94%', right: '66.72%', bottom: '61.37%', left: '-68.53%', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ flexShrink: 0, height: '627.002px', transform: 'rotate(195.813deg)', width: '616.04px' }}>
          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgVector6} />
          </div>
        </div>
      </div>
      <div style={{ position: 'absolute', display: 'flex', top: '38.13%', right: '-63.94%', bottom: '58.18%', left: '62.13%', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ flexShrink: 0, height: '627.002px', transform: 'rotate(344.187deg) scaleY(-1)', width: '616.04px' }}>
          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgVector7} />
          </div>
        </div>
      </div>

      {/* 利用者の声1 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', border: '1px solid rgba(50,41,31,0.5)', height: '1552px', left: '27px', borderRadius: '29px', top: '7028px', width: '690px' }} />
      <div style={{ position: 'absolute', lineHeight: 0, left: '63px', color: '#32291f', top: '7415px', letterSpacing: '2.8px', width: '624px', whiteSpace: 'pre-wrap' }}>
        <p style={{ fontWeight: 'normal', lineHeight: '42px', marginBottom: 0, fontSize: '28px' }}>自分では条件が厳しすぎて無理だと思っていました。</p>
        <p style={{ lineHeight: '42px', marginBottom: 0, fontSize: '28px' }}>&nbsp;</p>
        <p style={{ lineHeight: '42px', marginBottom: 0, fontSize: '28px' }}>
          <span style={{ fontWeight: 'normal' }}>でも、これまでの経験を一つずつ深掘りしてもらい、</span>
          <span style={{ fontWeight: 500, color: '#ed7243' }}>「こう伝えれば評価されるのか」と初めて腑に落ちました。</span>
        </p>
        <p style={{ lineHeight: '42px', marginBottom: 0, fontSize: '28px' }}>&nbsp;</p>
        <p style={{ fontWeight: 'normal', lineHeight: '42px', marginBottom: 0, fontSize: '28px' }}>添削後は面接でも自信をもって話せるようになりました。</p>
        <p style={{ lineHeight: '42px', marginBottom: 0, fontSize: '28px' }}>&nbsp;</p>
        <p style={{ fontWeight: 'normal', lineHeight: '36px', fontSize: '24px', color: '#888' }}>※プライバシー保護のため、表記を一部変更しています。</p>
      </div>
      <div style={{ position: 'absolute', backgroundColor: '#ed7243', height: '49.717px', left: '166px', top: '7341px', width: '179.928px' }} />
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 'normal', left: '186.57px', fontSize: '32px', color: 'white', top: '7345.5px', letterSpacing: '1.6px' }}>
        30代前半
      </p>
      <div style={{ position: 'absolute', backgroundColor: '#ed7243', height: '49.717px', left: '389px', top: '7341px', width: '220.175px' }} />
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 'normal', left: '393.74px', fontSize: '32px', color: 'white', top: '7345.69px', letterSpacing: '1.6px' }}>
        正社員未経験
      </p>

      {/* 利用者の声1 画像 */}
      <div
        style={{
          position: 'absolute',
          height: '450.574px',
          left: '183.78px',
          top: '6828.63px',
          width: '675.779px',
          maskImage: `url('${img}')`,
          WebkitMaskImage: `url('${img}')`,
          maskPosition: '81.222px 104.176px',
          WebkitMaskPosition: '81.222px 104.176px',
          maskSize: '201.289px 201.289px',
          WebkitMaskSize: '201.289px 201.289px',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat'
        }}
      >
        <img alt="" style={{ position: 'absolute', inset: 0, maxWidth: 'none', objectFit: 'cover', objectPosition: '50% 50%', pointerEvents: 'none', width: '100%', height: '100%' }} src={imgAdobeStock12291495202} />
      </div>
      <div style={{ position: 'absolute', lineHeight: 0, left: '375px', textAlign: 'center', top: '7134px', letterSpacing: '2px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        <p style={{ fontWeight: 500, lineHeight: '61px', marginBottom: 0, color: '#32291f', fontSize: '40px' }}>正社員経験なし・子育て中でも</p>
        <p style={{ fontWeight: 500, lineHeight: '61px', marginBottom: 0, fontSize: '40px' }}>
          <span style={{ color: '#ed7243' }}>"経験の見せ方"</span>
          <span style={{ color: '#32291f' }}>を変えて</span>
        </p>
        <p style={{ fontWeight: 500, lineHeight: '61px', fontSize: '40px' }}>
          <span style={{ color: '#ed7243' }}>正社員に内定</span>
        </p>
      </div>

      {/* 利用者の声2 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', border: '1px solid rgba(50,41,31,0.5)', height: '763px', left: '31px', borderRadius: '29px', top: '8732px', width: '692px' }} />
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '63px', color: '#32291f', fontSize: '28px', top: '9132px', letterSpacing: '2.8px', width: '630px', whiteSpace: 'pre-wrap' }}>
        転職の軸が定まらず、書類が通らなかった時期がありました。面接でも志望理由をうまく説明できませんでした。<span style={{ color: '#ed7243' }}>キャリアの軸を一緒に整理していただき、方向性が明確になりました。</span>その結果、新しい業種への転職に成功することができました。
        <span style={{ display: 'block', marginTop: '24px', fontSize: '24px', color: '#888' }}>※プライバシー保護のため、表記を一部変更しています。</span>
      </p>
      <div style={{ position: 'absolute', backgroundColor: '#ed7243', height: '47px', left: '157px', top: '9061px', width: '156px' }} />
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 'normal', left: '167.57px', fontSize: '32px', color: 'white', top: '9064.49px', letterSpacing: '1.6px' }}>
        30代後半
      </p>
      <div style={{ position: 'absolute', backgroundColor: '#ed7243', height: '47px', left: '354px', top: '9061px', width: '252px' }} />
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 'normal', left: '359.38px', fontSize: '32px', color: 'white', top: '9064.49px', letterSpacing: '1.6px' }}>
        新業種への挑戦
      </p>

      {/* 利用者の声2 画像 */}
      <div
        style={{
          position: 'absolute',
          height: '693.257px',
          left: '-234.21px',
          top: '8450.05px',
          width: '1039.759px',
          maskImage: `url('${img5}')`,
          WebkitMaskImage: `url('${img5}')`,
          maskPosition: '497.211px 193.947px',
          WebkitMaskPosition: '497.211px 193.947px',
          maskSize: '201px 201px',
          WebkitMaskSize: '201px 201px',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat'
        }}
      >
        <img alt="" style={{ position: 'absolute', inset: 0, maxWidth: 'none', objectFit: 'cover', objectPosition: '50% 50%', pointerEvents: 'none', width: '100%', height: '100%' }} src={imgAdobeStock12291495201} />
      </div>
      <div style={{ position: 'absolute', fontWeight: 500, lineHeight: 1.5, left: '381px', color: '#32291f', fontSize: '40px', textAlign: 'center', top: '8857px', letterSpacing: '2px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>方向性が決まらず迷っていた</p>
        <p style={{ marginBottom: 0 }}>30代女性が</p>
        <p><span style={{ color: '#ed7243' }}>新しい業種</span>での<span style={{ color: '#ed7243' }}>転職に成功</span></p>
      </div>

      {/* 実績テキスト */}
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: '48px', left: '35px', color: '#32291f', fontSize: '32px', top: '9620px', letterSpacing: '3.2px', width: '689px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>私たちは、これまでに100名以上の</p>
        <p style={{ marginBottom: 0 }}>キャリアチェンジを</p>
        <p style={{ marginBottom: 0 }}>サポートしてきました。</p>
        <p style={{ marginBottom: 0 }}>&nbsp;</p>
        <p style={{ marginBottom: 0 }}>AIやテンプレートでは対応できない、</p>
        <p style={{ marginBottom: 0 }}>
          一人ひとりの<span style={{ fontWeight: 'bold', color: '#ed7243' }}>「核となるストーリー」</span>
        </p>
        <p style={{ marginBottom: 0 }}>を引き出し、職務経歴書に</p>
        <p style={{ marginBottom: 0 }}>反映させています。</p>
        <p>
          <br aria-hidden="true" />
          この確かな実績こそが、あなたの選考突破を力強く後押しします。
        </p>
      </div>

      {/* CTA ボタン3 */}
      <div onClick={scrollToDiagnosisForm} style={{ position: 'absolute', left: '34px', top: '10306.76px', width: '676.024px', height: '136.046px', cursor: 'pointer' }}>
        <div style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', height: '136.046px', left: '0', borderRadius: '68.07px', top: '0', width: '676.024px' }} className="hover:opacity-90 transition-opacity" />
        <p style={{ position: 'absolute', fontWeight: 600, lineHeight: 'normal', left: '51px', fontStyle: 'normal', fontSize: '33.661px', color: 'white', top: '46.24px', letterSpacing: '1.683px' }}>
          無料で職務経歴書の診断を受ける
        </p>
        <div style={{ position: 'absolute', display: 'flex', height: '28.051px', alignItems: 'center', justifyContent: 'center', left: '614.31px', top: '54.66px', width: '16.83px' }}>
          <div style={{ flexShrink: 0, transform: 'rotate(90deg)' }}>
            <div style={{ height: '16.83px', position: 'relative', width: '28.051px' }}>
              <div style={{ position: 'absolute', bottom: '25%', left: '6.7%', right: '6.7%', top: 0 }}>
                <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgPolygon2} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <p style={{ position: 'absolute', fontWeight: 500, lineHeight: 'normal', left: '161px', color: '#32291f', fontSize: '28px', top: '10263px', letterSpacing: '1.4px' }}>
        通過した人の共通点を無料で体験
      </p>
      <div style={{ position: 'absolute', display: 'flex', height: '23.294px', alignItems: 'center', justifyContent: 'center', left: '143px', top: '10271px', width: '8.153px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(70.71deg)' }}>
          <div style={{ height: 0, position: 'relative', width: '24.679px' }}>
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, top: '-1.16px' }}>
              <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgLine8} />
            </div>
          </div>
        </div>
      </div>
      <div style={{ position: 'absolute', display: 'flex', height: '23.294px', alignItems: 'center', justifyContent: 'center', left: '610px', top: '10272px', width: '8.153px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(109.29deg) scaleY(-1)' }}>
          <div style={{ height: 0, position: 'relative', width: '24.679px' }}>
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, top: '-1.16px' }}>
              <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgLine9} />
            </div>
          </div>
        </div>
      </div>

      {/* 装飾 */}
      <div style={{ position: 'absolute', display: 'flex', height: '99.443px', alignItems: 'center', justifyContent: 'center', left: '-26px', top: '6306px', width: '110.296px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(148.366deg)' }}>
          <div style={{ height: '59.62px', position: 'relative', width: '92.818px' }}>
            <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={img} />
          </div>
        </div>
      </div>
      <div style={{ position: 'absolute', display: 'flex', height: '99.443px', alignItems: 'center', justifyContent: 'center', left: '637px', top: '6447px', width: '110.296px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(148.366deg)' }}>
          <div style={{ height: '59.62px', position: 'relative', width: '92.818px' }}>
            <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={img5} />
          </div>
        </div>
      </div>

      {/* 装飾小さい星 */}
      <div style={{ position: 'absolute', display: 'flex', top: '31.33%', right: '4.95%', bottom: '68.54%', left: '91.2%', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(148.366deg)', width: '20.965px', height: '20.965px' }}>
          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgVector8} />
          </div>
        </div>
      </div>
      <div style={{ position: 'absolute', display: 'flex', top: '31.09%', right: '-3.99%', bottom: '68.59%', left: '95.07%', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(135.086deg)', width: '47.339px', height: '47.339px' }}>
          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgVector9} />
          </div>
        </div>
      </div>
      <div style={{ position: 'absolute', display: 'flex', height: '182.743px', alignItems: 'center', justifyContent: 'center', left: '599.62px', top: '9636.99px', width: '201.168px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(283.036deg)' }}>
          <div style={{ height: '172.296px', position: 'relative', width: '147.685px' }}>
            <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={img6} />
          </div>
        </div>
      </div>

      {/* メディアも認めた */}
      <div style={{ position: 'absolute', background: 'linear-gradient(to top, rgba(240,152,25,0.3), rgba(255,81,47,0.3))', height: '297px', left: '-14px', top: '10571px', width: '778px' }} />
      <div style={{ position: 'absolute', fontWeight: 'bold', lineHeight: '90px', left: '361.5px', color: '#32291f', fontSize: '60px', textAlign: 'center', top: '10586px', letterSpacing: '3px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>メディアも認めた</p>
        <p>「職務経歴書のプロ」</p>
      </div>
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 'normal', left: '49px', color: '#32291f', fontSize: '32px', top: '10795px', letterSpacing: '0.64px' }}>
        その知識と経験が、あなたの未来を切り拓く
      </p>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '375px', color: '#32291f', fontSize: '28px', textAlign: 'center', top: '10932px', letterSpacing: '2.8px', transform: 'translateX(-50%)', width: '686px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>書籍で公開されている、「採用担当者の心理」を突く独自のロジックを、あなたの職務経歴書に</p>
        <p>直接適用します。</p>
      </div>

      {/* 書籍画像 */}
      <div
        style={{
          position: 'absolute',
          height: '313.44px',
          left: '262.15px',
          top: '11121.95px',
          width: '217.934px',
          maskImage: `url('${img7}')`,
          WebkitMaskImage: `url('${img7}')`,
          maskPosition: '3.847px -17.953px',
          WebkitMaskPosition: '3.847px -17.953px',
          maskSize: '218px 355.26px',
          WebkitMaskSize: '218px 355.26px',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat'
        }}
      >
        <img alt="" style={{ position: 'absolute', inset: 0, maxWidth: 'none', objectFit: 'cover', objectPosition: '50% 50%', pointerEvents: 'none', width: '100%', height: '100%' }} src={imgImg94681} />
      </div>

      {/* 著者画像 */}
      <div
        style={{
          position: 'absolute',
          height: '351.809px',
          left: '261.88px',
          top: '11630.86px',
          width: '234.568px',
          maskImage: `url('${img6}')`,
          WebkitMaskImage: `url('${img6}')`,
          maskPosition: '1.122px 26.143px',
          WebkitMaskPosition: '1.122px 26.143px',
          maskSize: '218px 261.6px',
          WebkitMaskSize: '218px 261.6px',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat'
        }}
      >
        <img alt="" style={{ position: 'absolute', inset: 0, maxWidth: 'none', objectFit: 'cover', objectPosition: '50% 50%', pointerEvents: 'none', width: '100%', height: '100%' }} src={img202511281800251} />
      </div>

      <div style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 1.5, left: '384.5px', color: '#32291f', fontSize: '28px', textAlign: 'center', top: '11459px', letterSpacing: '1.4px', transform: 'translateX(-50%)', width: '719px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>{`『職務経歴書で"あなたの実績"を最大限 に魅せる！　`}</p>
        <p style={{ marginBottom: 0 }}>{`　～凡人でも即実践！　`}</p>
        <p>あなたの価値を最大化する秘訣』</p>
      </div>
      <p style={{ position: 'absolute', fontWeight: 500, lineHeight: 'normal', left: '295px', color: '#32291f', fontSize: '32px', top: '11944px', letterSpacing: '0.64px' }}>
        仲丸 武宏
      </p>
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 'normal', left: '166px', color: '#32291f', fontSize: '28px', top: '11997px', letterSpacing: '2.8px', width: '397px', whiteSpace: 'pre-wrap' }}>
        Xrosspoint代表取締役社長
      </p>
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '364px', color: '#32291f', fontSize: '28px', textAlign: 'center', top: '12045px', letterSpacing: '2.8px', transform: 'translateX(-50%)', width: '536px', whiteSpace: 'pre-wrap' }}>
        普段はDXや業務改善などの伴走型経営コンサルタントとして活躍。そのコンサルタントとしての高度な言語化スキルとレジュメ作成ノウハウを活かし、求職者のキャリアアップを支援。
      </p>

      <div style={{ position: 'absolute', fontWeight: 500, lineHeight: 1.5, left: '367px', color: '#32291f', fontSize: '32px', textAlign: 'center', top: '12335px', letterSpacing: '3.2px', transform: 'translateX(-50%)', width: '686px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>個人の実績を深掘りするための</p>
        <p style={{ marginBottom: 0 }}>思考プロセスを言語化することにより、</p>
        <p style={{ marginBottom: 0 }}>実績の再現性をアピールし、</p>
        <p>選考通過率向上を実現します。</p>
      </div>

      {/* CTA ボタン4 */}
      <div onClick={scrollToDiagnosisForm} style={{ position: 'absolute', left: '26px', top: '12646px', width: '676.024px', height: '136.046px', cursor: 'pointer' }}>
        <div style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', height: '136.046px', left: '0', borderRadius: '68.07px', top: '0', width: '676.024px' }} className="hover:opacity-90 transition-opacity" />
        <p style={{ position: 'absolute', fontWeight: 500, lineHeight: 'normal', left: '61.71px', fontSize: '33.661px', color: 'white', top: '44.6px', letterSpacing: '1.683px' }}>
          無料で職務経歴書の診断を受ける
        </p>
        <div style={{ position: 'absolute', display: 'flex', height: '28.051px', alignItems: 'center', justifyContent: 'center', left: '614.31px', top: '54.42px', width: '16.83px' }}>
          <div style={{ flexShrink: 0, transform: 'rotate(90deg)' }}>
            <div style={{ height: '16.83px', position: 'relative', width: '28.051px' }}>
              <div style={{ position: 'absolute', bottom: '25%', left: '6.7%', right: '6.7%', top: 0 }}>
                <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgPolygon2} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <p style={{ position: 'absolute', fontWeight: 500, lineHeight: 'normal', left: '115px', color: '#32291f', fontSize: '28px', top: '12607px', letterSpacing: '1.4px' }}>
        プロにあなたの強みを見つけてもらう
      </p>
      <div style={{ position: 'absolute', display: 'flex', height: '23.294px', alignItems: 'center', justifyContent: 'center', left: '102px', top: '12614px', width: '8.153px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(70.71deg)' }}>
          <div style={{ height: 0, position: 'relative', width: '24.679px' }}>
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, top: '-1.16px' }}>
              <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgLine8} />
            </div>
          </div>
        </div>
      </div>
      <div style={{ position: 'absolute', display: 'flex', height: '23.294px', alignItems: 'center', justifyContent: 'center', left: '619px', top: '12615px', width: '8.153px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(109.29deg) scaleY(-1)' }}>
          <div style={{ height: 0, position: 'relative', width: '24.679px' }}>
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, top: '-1.16px' }}>
              <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgLine9} />
            </div>
          </div>
        </div>
      </div>

      {/* ご利用の流れ (サービスの流れ) */}
      <div id="service-flow" style={{ position: 'absolute', background: 'linear-gradient(to bottom, rgba(255,81,47,0.3), rgba(240,152,25,0.3))', height: '1911px', left: 0, top: '12892px', width: '750px' }} />
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 'normal', left: '194px', color: '#32291f', fontSize: '60px', top: '12991.05px', letterSpacing: '3px' }}>
        ご利用の流れ
      </p>

      {/* STEP 1 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', height: '283px', left: '31px', top: '13127.05px', width: '692px' }} />
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', fontWeight: 'bold', lineHeight: 'normal', left: '210px', fontStyle: 'normal', color: '#ed7243', fontSize: '40px', top: '13168.05px', letterSpacing: '2px' }}>
        STEP 01
      </p>
      <div style={{ position: 'absolute', lineHeight: '48px', left: '210px', color: '#32291f', fontSize: '32px', top: '13232.05px', letterSpacing: '3.2px', width: '513px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>フォームに必要事項を入力するだけで、あなたの強み整理が</p>
        <p>スタートします。</p>
      </div>
      <div style={{ position: 'absolute', height: '89.47px', left: '81px', top: '13218.05px', width: '79.973px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgAdobeStock3889188531} />
      </div>

      {/* STEP 2 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', height: '283px', left: '31px', top: '13474.05px', width: '692px' }} />
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 'normal', left: '211.98px', color: '#ed7243', fontSize: '40px', top: '13504.05px', letterSpacing: '2px', whiteSpace: 'nowrap' }}>
        STEP 02
      </p>
      <div style={{ position: 'absolute', height: '74.675px', left: '71px', top: '13582.05px', width: '104.005px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgAdobeStock4267875071} />
      </div>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: '48px', left: '212px', color: '#32291f', fontSize: '32px', top: '13572.05px', letterSpacing: '3.2px' }}>
        <p style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>担当者がヒアリングを行い、</p>
        <p style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>経験・実績を深掘りして</p>
        <p style={{ whiteSpace: 'nowrap' }}>"伝わる材料"を収集します。</p>
      </div>

      {/* STEP 3 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', height: '283px', left: '31px', top: '13821.05px', width: '692px' }} />
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 'normal', left: '218px', color: '#ed7243', fontSize: '40px', top: '13836.05px', letterSpacing: '2px' }}>
        STEP 03
      </p>
      <div style={{ position: 'absolute', height: '104.161px', left: '88px', top: '13914.05px', width: '69.91px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgAdobeStock4738159761} />
      </div>
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: '48px', left: '218px', color: '#32291f', fontSize: '32px', top: '13898.05px', letterSpacing: '3.2px', width: '501px', whiteSpace: 'pre-wrap' }}>
        添削・作成スタート。
        <br aria-hidden="true" />
        プロがあなたの実績を言語し、
        <br aria-hidden="true" />
        面接で話しやすい構造に整えます。
      </p>

      {/* STEP 4 */}
      <div style={{ position: 'absolute', backgroundColor: 'white', height: '283px', left: '31px', top: '14168.05px', width: '692px' }} />
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 'normal', left: '213px', color: '#ed7243', fontSize: '40px', top: '14204.05px', letterSpacing: '2px' }}>
        STEP 04
      </p>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: '48px', left: '213px', color: '#32291f', fontSize: '32px', top: '14268.05px', letterSpacing: '3.2px', width: '506px', whiteSpace: 'pre-wrap' }}>
        <p style={{ marginBottom: 0 }}>
          完成した職務経歴書を納品。
          <br aria-hidden="true" />
          必要に応じて面接対策も
        </p>
        <p>サポートします。</p>
      </div>
      <div
        style={{ position: 'absolute', left: '80px', top: '14220px', width: '72px', height: '72px' }}
      >
        <img alt="" style={{ display: 'block', width: '100%', height: '100%' }} src={imgStepIcon4} />
      </div>

      {/* CTA ボタン5 */}
      <div onClick={scrollToDiagnosisForm} style={{ position: 'absolute', left: '37px', top: '14586.81px', width: '676.024px', height: '136.046px', cursor: 'pointer' }}>
        <div style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', height: '136.046px', left: '0', borderRadius: '68.07px', top: '0', width: '676.024px' }} className="hover:opacity-90 transition-opacity" />
        <p style={{ position: 'absolute', fontWeight: 500, lineHeight: 'normal', left: '73px', fontSize: '33.661px', color: 'white', top: '48.24px', letterSpacing: '1.683px' }}>
          無料で職務経歴書の診断を受ける
        </p>
        <div style={{ position: 'absolute', display: 'flex', height: '28.051px', alignItems: 'center', justifyContent: 'center', left: '614.31px', top: '54.65px', width: '16.83px' }}>
          <div style={{ flexShrink: 0, transform: 'rotate(90deg)' }}>
            <div style={{ height: '16.83px', position: 'relative', width: '28.051px' }}>
              <div style={{ position: 'absolute', bottom: '25%', left: '6.7%', right: '6.7%', top: 0 }}>
                <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgPolygon2} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <p style={{ position: 'absolute', fontWeight: 500, lineHeight: 'normal', left: '250px', color: '#32291f', fontSize: '28px', top: '14545px', letterSpacing: '1.4px' }}>
        最短3分で申し込み
      </p>
      {/* 装飾チェックラインを非表示化 */}

      {/* 3つのサポート */}
      <div style={{ position: 'absolute', height: '343.162px', left: '525px', top: '15922.53px', width: '371px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={img7} />
      </div>

      <div
        style={{
          position: 'absolute',
          height: '359.852px',
          left: '92.53px',
          top: '15206.55px',
          width: '558.951px',
          maskImage: `url('${img8}')`,
          WebkitMaskImage: `url('${img8}')`,
          maskPosition: '13.211px 18.921px',
          WebkitMaskPosition: '13.211px 18.921px',
          maskSize: '533.762px 315.524px',
          WebkitMaskSize: '533.762px 315.524px',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat'
        }}
      >
        <img alt="" style={{ position: 'absolute', inset: 0, maxWidth: 'none', objectFit: 'cover', objectPosition: '50% 50%', pointerEvents: 'none', width: '100%', height: '100%' }} src={imgAdobeStock3889188532} />
      </div>
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: '48px', left: '369px', color: '#ed7243', fontSize: '32px', textAlign: 'center', top: '15607px', letterSpacing: '1.6px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        （あなたの強みの可視化）
      </p>
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: '48px', left: '368px', fontStyle: 'normal', color: '#ed7243', fontSize: '36px', textAlign: 'center', top: '15559px', letterSpacing: '1.8px', transform: 'translateX(-50%)' }}>
        情報整理
      </p>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '369.5px', color: '#32291f', fontSize: '32px', textAlign: 'center', top: '15669px', letterSpacing: '3.2px', transform: 'translateX(-50%)' }}>
        <p style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>経験・実績を整理し、強みが</p>
        <p style={{ whiteSpace: 'nowrap' }}>ひと目でわかる構成に整えます。</p>
      </div>
      <p style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', WebkitBackgroundClip: 'text', backgroundClip: 'text', fontFamily: 'Helvetica, sans-serif', fontWeight: 'bold', lineHeight: 'normal', left: '135.5px', fontStyle: 'normal', fontSize: '105.175px', textAlign: 'center', color: 'transparent', top: '15165px', letterSpacing: '2.1035px', transform: 'translateX(-50%)' }}>
        01
      </p>

      <div id="fee-structure" style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 1.5, left: '369px', color: '#32291f', fontSize: '60px', textAlign: 'center', top: '14883px', letterSpacing: '3px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0 }}>あなたのキャリアを</p>
        <p style={{ marginBottom: 0 }}>引き出す</p>
        <p>3つのサポート</p>
      </div>

      {/* 面接対策 */}
      <div
        style={{
          position: 'absolute',
          height: '338.628px',
          left: '52px',
          top: '15842px',
          width: '736.211px',
          maskImage: `url('${imgSupport2Mask}')`,
          WebkitMaskImage: `url('${imgSupport2Mask}')`,
          maskPosition: '55.996px 0px',
          WebkitMaskPosition: '55.996px 0px',
          maskSize: '531px 336.943px',
          WebkitMaskSize: '531px 336.943px',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat'
        }}
      >
        <img alt="" style={{ position: 'absolute', inset: 0, maxWidth: 'none', objectFit: 'cover', objectPosition: '50% 50%', pointerEvents: 'none', width: '100%', height: '100%' }} src={imgAdobeStock4267875072} />
      </div>
      <div style={{ position: 'absolute', fontWeight: 'bold', lineHeight: '48px', left: '374.5px', color: '#ed7243', textAlign: 'center', top: '16195px', letterSpacing: '1.4px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0, fontSize: '36px', letterSpacing: '1.8px' }}>面接対策</p>
        <p style={{ fontSize: '32px', letterSpacing: '1.6px' }}>（想定質問×フィードバック）</p>
      </div>
      <p style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', WebkitBackgroundClip: 'text', backgroundClip: 'text', fontFamily: 'Helvetica, sans-serif', fontWeight: 'bold', lineHeight: 'normal', left: '130.5px', fontStyle: 'normal', fontSize: '80px', textAlign: 'center', color: 'transparent', top: '15796px', letterSpacing: '1.6px', transform: 'translateX(-50%)' }}>
        02
      </p>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '372px', color: '#32291f', fontSize: '32px', textAlign: 'center', top: '16307px', letterSpacing: '3.2px', transform: 'translateX(-50%)' }}>
        <p style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>「聞かれたら困る質問」まで想定し、</p>
        <p style={{ whiteSpace: 'nowrap' }}>自信を持って話せる状態をつくります。</p>
      </div>

      {/* 装飾 */}
      <div style={{ position: 'absolute', display: 'flex', top: '71.83%', right: '83.65%', bottom: '26.63%', left: '-26.53%', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(269.479deg)', width: '318.729px', height: '318.729px' }}>
          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgVector11} />
          </div>
        </div>
      </div>

      {/* 企業マッピング */}
      <div
        style={{
          position: 'absolute',
          height: '356.114px',
          left: '108px',
          top: '16478.04px',
          width: '534.105px',
          maskImage: `url('${imgSupport3Mask}')`,
          WebkitMaskImage: `url('${imgSupport3Mask}')`,
          maskPosition: '0px 0.965px',
          WebkitMaskPosition: '0px 0.965px',
          maskSize: '531px 336.943px',
          WebkitMaskSize: '531px 336.943px',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat'
        }}
      >
        <img alt="" style={{ position: 'absolute', inset: 0, maxWidth: 'none', objectFit: 'cover', objectPosition: '50% 50%', pointerEvents: 'none', width: '100%', height: '100%' }} src={imgAdobeStock4738159762} />
      </div>
      <div style={{ position: 'absolute', fontWeight: 'bold', lineHeight: '48px', left: '373.5px', color: '#ed7243', textAlign: 'center', top: '16830px', letterSpacing: '1.4px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        <p style={{ marginBottom: 0, fontSize: '36px' }}>企業マッピング</p>
        <p style={{ fontSize: '32px' }}>（あなたに合う求人の方向性）</p>
      </div>
      <p style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', WebkitBackgroundClip: 'text', backgroundClip: 'text', fontFamily: 'Helvetica, sans-serif', fontWeight: 'bold', lineHeight: 'normal', left: '131.5px', fontStyle: 'normal', fontSize: '80px', textAlign: 'center', color: 'transparent', top: '16433px', letterSpacing: '1.6px', transform: 'translateX(-50%)' }}>
        03
      </p>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '374px', color: '#32291f', fontSize: '32px', textAlign: 'center', top: '16942px', letterSpacing: '3.2px', transform: 'translateX(-50%)' }}>
        <p style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>希望条件・実績を基に、</p>
        <p style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>転職の方向性が明確になるレポートを</p>
        <p style={{ whiteSpace: 'nowrap' }}>提示します。</p>
      </div>
      <div style={{ position: 'absolute', display: 'flex', height: '262.965px', alignItems: 'center', justifyContent: 'center', left: '-60px', top: '16985.96px', width: '248.483px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(24.788deg)' }}>
          <div style={{ height: '207.51px', position: 'relative', width: '177.87px' }}>
            <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={img8} />
          </div>
        </div>
      </div>

      {/* よくある質問 */}
      <p style={{ position: 'absolute', fontWeight: 'bold', lineHeight: 'normal', left: '381.5px', color: '#32291f', fontSize: '60px', textAlign: 'center', top: '17197px', letterSpacing: '3px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        よくある質問
      </p>

      {/* Q1 */}
      <div style={{ position: 'absolute', background: 'linear-gradient(to bottom, rgba(255,81,47,0.3), rgba(240,152,25,0.3))', height: '214px', left: '-15px', top: '17323px', width: '779px' }} />
      <div style={{ position: 'absolute', left: '41px', width: '58px', height: '58px', top: '17348px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgEllipse23} />
      </div>
      <div style={{ position: 'absolute', left: '41px', width: '58px', height: '58px', top: '17439px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgEllipse24} />
      </div>
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '70px', fontStyle: 'normal', fontSize: '28px', textAlign: 'center', color: 'white', top: '17361px', letterSpacing: '1.4px', transform: 'translateX(-50%)' }}>
        Q
      </p>
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '70.5px', fontStyle: 'normal', color: '#ed7243', fontSize: '28px', textAlign: 'center', top: '17452px', letterSpacing: '1.4px', transform: 'translateX(-50%)' }}>
        A
      </p>
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 'normal', left: '334.5px', color: '#32291f', fontSize: '28px', textAlign: 'center', top: '17360px', letterSpacing: '2.8px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        初回の相談料はかかりますか？
      </p>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '120px', color: '#32291f', fontSize: '28px', top: '17426px', letterSpacing: '2.8px' }}>
        <p style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>無料です。</p>
        <p style={{ whiteSpace: 'nowrap' }}>まずは職務経歴書の現状診断を行います。</p>
      </div>

      {/* Q2 */}
      <div style={{ position: 'absolute', background: 'linear-gradient(to bottom, rgba(255,81,47,0.3), rgba(240,152,25,0.3))', height: '274px', left: '-15px', top: '17593px', width: '779px' }} />
      <div style={{ position: 'absolute', left: '43px', width: '58px', height: '58px', top: '17624px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgEllipse23} />
      </div>
      <div style={{ position: 'absolute', left: '43px', width: '58px', height: '58px', top: '17705px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgEllipse24} />
      </div>
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '72px', fontStyle: 'normal', fontSize: '28px', textAlign: 'center', color: 'white', top: '17637px', letterSpacing: '1.4px', transform: 'translateX(-50%)' }}>
        Q
      </p>
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '72.5px', fontStyle: 'normal', color: '#ed7243', fontSize: '28px', textAlign: 'center', top: '17721px', letterSpacing: '1.4px', transform: 'translateX(-50%)' }}>
        A
      </p>
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 'normal', left: '414.5px', color: '#32291f', fontSize: '28px', textAlign: 'center', top: '17636px', letterSpacing: '2.8px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        AIで作った職務経歴書でも大丈夫ですか？
      </p>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '123px', color: '#32291f', fontSize: '28px', top: '17705px', letterSpacing: '2.8px' }}>
        <p style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>問題ありません。</p>
        <p style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>AIで作られた文章は強みが埋もれがちなので、</p>
        <p style={{ whiteSpace: 'nowrap' }}>プロの観点からしっかり再構築します。</p>
      </div>

      {/* Q3 */}
      <div style={{ position: 'absolute', background: 'linear-gradient(to bottom, rgba(255,81,47,0.3), rgba(240,152,25,0.3))', height: '240px', left: '-16px', top: '17923px', width: '779px' }} />
      <div style={{ position: 'absolute', left: '42px', width: '58px', height: '58px', top: '17954px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgEllipse23} />
      </div>
      <div style={{ position: 'absolute', left: '42px', width: '58px', height: '58px', top: '18035px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgEllipse24} />
      </div>
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '71px', fontStyle: 'normal', fontSize: '28px', textAlign: 'center', color: 'white', top: '17967px', letterSpacing: '1.4px', transform: 'translateX(-50%)' }}>
        Q
      </p>
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '71.5px', fontStyle: 'normal', color: '#ed7243', fontSize: '28px', textAlign: 'center', top: '18048px', letterSpacing: '1.4px', transform: 'translateX(-50%)' }}>
        A
      </p>
      <p style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 'normal', left: '398px', color: '#32291f', fontSize: '28px', textAlign: 'center', top: '17966px', letterSpacing: '2.8px', transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>
        未経験業界への転職も相談できますか？
      </p>
      <div style={{ position: 'absolute', fontWeight: 'normal', lineHeight: 1.5, left: '123px', color: '#32291f', fontSize: '28px', top: '18038px', letterSpacing: '2.8px' }}>
        <p style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>可能です。これまでの経験から強みを</p>
        <p style={{ whiteSpace: 'nowrap' }}>抽出し、方向性を整理します。</p>
      </div>

      {/* CTA5 */}
      <div
        style={{
          position: 'absolute',
          height: '1369px',
          left: '-626px',
          top: '17627px',
          width: '2052px',
          maskImage: `url('${imgAdobeStock4588800721}')`,
          WebkitMaskImage: `url('${imgAdobeStock4588800721}')`,
          maskPosition: '-20px 656px',
          WebkitMaskPosition: '-20px 656px',
          maskSize: '2041px 484px',
          WebkitMaskSize: '2041px 484px',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat'
        }}
      >
        <img alt="" style={{ position: 'absolute', inset: 0, maxWidth: 'none', objectFit: 'cover', objectPosition: '50% 50%', pointerEvents: 'none', width: '100%', height: '100%' }} src={imgAdobeStock4588800722} />
      </div>
      <div style={{ position: 'absolute', height: '484px', left: '-622px', top: '18283px', width: '2034px', backgroundImage: 'linear-gradient(90deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%), linear-gradient(90deg, rgba(237, 114, 67, 0.41) 0%, rgba(237, 114, 67, 0.41) 100%)' }} />

      {/* CTA ボタン6 */}
      <div onClick={scrollToDiagnosisForm} style={{ position: 'absolute', left: '36px', top: '18478.76px', width: '676.024px', height: '136.046px', cursor: 'pointer' }}>
        <div style={{ position: 'absolute', background: 'linear-gradient(to right, #f09819, #ff512f)', height: '136.046px', left: '0', borderRadius: '68.07px', top: '0', width: '676.024px' }} className="hover:opacity-90 transition-opacity" />
        <p style={{ position: 'absolute', fontWeight: 500, lineHeight: 'normal', left: '70px', fontSize: '33.661px', color: 'white', top: '49.24px', letterSpacing: '1.683px' }}>
          無料で職務経歴書の診断を受ける
        </p>
        <div style={{ position: 'absolute', display: 'flex', height: '28.051px', alignItems: 'center', justifyContent: 'center', left: '614.31px', top: '54.66px', width: '16.83px' }}>
          <div style={{ flexShrink: 0, transform: 'rotate(90deg)' }}>
            <div style={{ height: '16.83px', position: 'relative', width: '28.051px' }}>
              <div style={{ position: 'absolute', bottom: '25%', left: '6.7%', right: '6.7%', top: 0 }}>
                <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgPolygon2} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <p style={{ position: 'absolute', fontWeight: 500, lineHeight: 'normal', left: '194px', fontSize: '28px', color: 'white', top: '18437px', letterSpacing: '1.4px' }}>
        3分で完了・まずは診断から
      </p>
      <div style={{ position: 'absolute', display: 'flex', height: '23.294px', alignItems: 'center', justifyContent: 'center', left: '179px', top: '18443px', width: '8.153px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(70.71deg)' }}>
          <div style={{ height: 0, position: 'relative', width: '24.679px' }}>
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, top: '-1.16px' }}>
              <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgLine10} />
            </div>
          </div>
        </div>
      </div>
      <div style={{ position: 'absolute', display: 'flex', height: '23.294px', alignItems: 'center', justifyContent: 'center', left: '569px', top: '18443px', width: '8.153px' }}>
        <div style={{ flexShrink: 0, transform: 'rotate(109.29deg) scaleY(-1)' }}>
          <div style={{ height: 0, position: 'relative', width: '24.679px' }}>
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, top: '-1.16px' }}>
              <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={imgLine11} />
            </div>
          </div>
        </div>
      </div>

      {/* 診断フォーム */}
      <div id="diagnosis-form" style={{ position: 'absolute', left: '31px', top: '18887px', width: '689px' }}>
        <DiagnosisForm />
      </div>

      {/* フッター */}
      <div style={{ position: 'absolute', backgroundColor: '#32291f', height: '132px', left: '-627px', top: '19820px', width: '2003px' }} />
      <p style={{ position: 'absolute', fontFamily: 'Helvetica, sans-serif', lineHeight: 'normal', left: '206px', fontStyle: 'normal', fontSize: '16px', color: 'white', top: '19877px', letterSpacing: '0.8px' }}>
        © 2025 Xrosspoint Inc. All rights reserved.
      </p>
      <div style={{ position: 'absolute', height: '107.085px', left: '235px', top: '19515px', width: '281.266px' }}>
        <img alt="" style={{ display: 'block', maxWidth: 'none', width: '100%', height: '100%' }} src={img9} />
      </div>
      <div style={{ position: 'absolute', display: 'flex', gap: '35px', alignItems: 'center', lineHeight: 'normal', left: '151px', color: '#32291f', fontSize: '20px', top: '19669px', letterSpacing: '1px' }}>
        <p style={{ position: 'relative', flexShrink: 0 }}>
          利用規約
        </p>
        <p style={{ position: 'relative', flexShrink: 0 }}>
          お問い合わせ
        </p>
        <p style={{ position: 'relative', flexShrink: 0 }}>
          利用手順
        </p>
        <p style={{ position: 'relative', flexShrink: 0 }}>
          FAQ
        </p>
      </div>
      <div style={{ position: 'absolute', display: 'flex', gap: '35px', alignItems: 'center', lineHeight: 'normal', left: '219px', color: '#32291f', fontSize: '16px', top: '19725px', letterSpacing: '0.8px' }}>
        <p style={{ position: 'relative', flexShrink: 0 }}>
          個人情報利用許諾
        </p>
        <p style={{ position: 'relative', flexShrink: 0 }}>
          特定商取引法
        </p>
      </div>
    </div>
  );
}
